export default "__VITE_ASSET__CLCAcnjG__"